window.ManufacturerData = [
  {
    plant_code: "A",
    plant_name: "Reve Pharma",
    address: "Plot No- 78, STICE Musalgaon, Sinnar, Nashik, Maharashtra, India – 422112.",
    ml_no: "NKD/C-72"
  },
  {
    plant_code: "B",
    plant_name: "Kain Cosmeceuticals Private Limited",
    address: "Unit 2A, Survey No. 63, Village Horale, Off Khopoli Pen Road, Taluka Khalapur, Raigad,Maharashtra, India - 410203.",
    ml_no: "MH/105559"
  },
  {
    plant_code: "C",
    plant_name: "N.G. Electro Products Pvt. Ltd.",
    address: "Unit II, Plot No.-36, HIMUDA Industrial Area, Phase-IV, Bhatolikalan, Baddi, Dist: Solan(H.P.) - 173205, Himachal Pradesh, India.",
    ml_no: "HIM/COS/18/266"
  },
  {
    plant_code: "D",
    plant_name: "Aurumine Naturals Pvt. Ltd.",
    address: "Plot 111, STICE, Musalgaon, Sinnar, Nashik, Maharashtra, India- 422112.",
    ml_no: "MH/104302"
  },  
  {
    plant_code: "E",
    plant_name: "N.G. Electro Products Pvt. Ltd.",
    address: "Unit - I, Plot No-51 &amp; 52, HIMUDA Industrial Area, Phase IV, Bhatolikalan, Tehsil Baddi, Dist. Solan, Himachal Pradesh-173205.",
    ml_no: "HIM/COS/12/166"
  },
  {
    plant_code: "F",
    plant_name: "Cheryl Laboratories Private Limited.",
    address: "Plot No. A-328, 329, 330, T.T.C. Industrial Area, M.I.D.C., Mahape, Navi Mumbai, Maharashtra, India- 400710.",
    ml_no: "MH/106142"
  },
  {
    plant_code: "G",
    plant_name: "Wonder Group (M/s Sai Corporation)",
    address: "Plot No. 353/196/186/1-2, Village-Johron, Trilokpur Road, Kala Amb, District Sirmour, Himachal Pradesh, India-173030.",
    ml_no: "N-COS/16/43"
  },
  {
    plant_code: "H",
    plant_name: "Yasharth Wellness Solutions Pvt. Ltd.",
    address: "Plot No. G41, Additional MIDC, Via Dewoolwada, Nerur, Kudal - 416525, Dist - Sindhudurg, Maharashtra, India.",
    ml_no: "MH/104056A"
  },
  {
    plant_code: "I",
    plant_name: "Aelius Parallel Holdings Pvt. Ltd.",
    address: "GP-55, Sector 18, Gurugram, 122015",
    ml_no: "312-Cos(H)"
  },
  {
    plant_code: "J",
    plant_name: "Ananya Herbal Pvt. Ltd.",
    address: "KH. No. 6//6,7,7//8/2 MIN.,9 MIN.,10, Village- Safiabad, District- Sonipat, Haryana, India - 131029.",
    ml_no: "293 COS(H)"
  },
  {
    plant_code: "K",
    plant_name: "Arovea Formulations Pvt. Ltd.",
    address: "Survey No- 622, Khavad, Vekra Road, Village: Khavad, Ta: Kadi, Di: Mehsana-382165, Gujarat, India.",
    ml_no: "GC/1847"
  },
  {
    plant_code: "L",
    plant_name: "Zymo Cosmetics",
    address: "Block No. 115, Santej Vadsar Road, Santej, Gujrat, India- 382721.",
    ml_no: "M-GC/1041"
  },
  {
    plant_code: "M",
    plant_name: "Ultra Beauty Care Pvt. Ltd",
    address: "Plot No. C-15, M.I.D.C., Five Star Industrial Area, Shendra, Aurangabad Maharashtra, India- 431201.",
    ml_no: "MH/104544"
  },
  {
    plant_code: "N",
    plant_name: "Color Theory Pvt. Ltd.",
    address: "Block No.309-1/309-2, Ranu, Near IPCA Laboratory, Padra, Vadodara, Gujarat - 391445.",
    ml_no: "GC/2015"
  },
  {
    plant_code: "O",
    plant_name: "Helios Packaging Pvt. Ltd.",
    address: "A-140, EPIP Industrial Area, Neemrana, Distt.- Alwar - 301705, Rajasthan, India",
    ml_no: "M Raj-2458-C"
  },
  {
    plant_code: "P",
    plant_name: "Aroma De France",
    address: "Block No. 324, Vill. Ranu, Ta. Padra, Dist. Vadodara, Gujarat - 391445, India",
    ml_no: "GC/942"
  },
  {
    plant_code: "Q",
    plant_name: "Kapco International Limited",
    address: "Plot No. 10-11, Sector 3, Parwanoo, Himachal Pradesh - 173220, India",
    ml_no: "S-COS/10/19"
  },
  {
    plant_code: "R",
    plant_name: "Artline Cosmetics Pvt. Ltd.",
    address: "Survey No.- 338/02 (New Survey No. 1674), Nr. Balda Ind Park, Balda, Killa Pardi, Dist. Valsad, Gujarat - 396125, India",
    ml_no: "GC/1691"
  }
];


(function() {
    const data = window.ManufacturerData || [];
    const tbody = document.getElementById('manufacturerBody');
    if (!tbody || !Array.isArray(data)) return;

    let html = '';
    data.forEach((row, i) => {
      html += `
        <tr>
          <td data-label="Sr.No">${i + 1}</td>
          <td data-label="Plant Code">${row.plant_code || ''}</td>
          <td data-label="Plant Name">${row.plant_name || ''}</td>
          <td data-label="Plant Address">${row.address || ''}</td>
          <td data-label="M.L. No.">${row.ml_no || ''}</td>
        </tr>
      `;
    });

    tbody.innerHTML = html;
  })();